import CryptoAes from 'crypto-js/aes';
import CtyptoUtf8 from 'crypto-js/enc-utf8'

export function AesEncrypt(plaintext: string) : string {
    try {
        return CryptoAes.encrypt(plaintext, process.env.REACT_APP_PUBLIC_SECRET_KEY || "").toString()
    } catch (error) {
        console.error(error)
        return "";
    }
}    


export function AesDecrypt(ciphertext: string) : string {
    try {
        return CryptoAes.decrypt(ciphertext, process.env.REACT_APP_PUBLIC_SECRET_KEY || "").toString(CtyptoUtf8)
    } catch (error) {
        console.error(error)
        return "";
    }
}